import React, { useState } from "react";
import { Button, Form, Input, notification } from "antd";
import { useAuth } from "context/providers/auth";
import { handleErrors } from "helpers/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { password_regexp } from "helpers/regexp";
import AuthLayout from "components/AuthLayout";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reset_password_token = searchParams.get("reset_password_token");
  const [is_loading, setLoading] = useState(false);
  const { handleChangePassword } = useAuth();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const message = await handleChangePassword({
        ...values,
        reset_password_token,
      });
      notification.success({
        message,
      });
      navigate("/");
    } catch (error) {
      notification.error({ message: handleErrors(error) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Zmień hasło">
      <div className="auth-page__form">
        <Form
          name="basic"
          initialValues={{
            password: "",
            password_confirmation: "",
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="Hasło"
            name="password"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Hasło jest wymagane!",
              },
              {
                max: 128,
                message: "Przekroczono maksymalną ilość znaków!",
              },
              {
                min: 8,
                message: "Hasło musi mieć co najmniej 8 znaków!",
              },
              {
                pattern: password_regexp,
                message:
                  "Hasło musi zawierać przynajmniej jedną dużą literę, jedną cyfrę i jeden znak specjalny!",
              },
            ]}
          >
            <Input.Password maxLength={128} />
          </Form.Item>
          <Form.Item
            label="Potwierdź hasło"
            name="password_confirmation"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Potwierdzenie hasła jest wymagane!",
              },

              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Hasła muszą być takie same!")
                  );
                },
              }),
            ]}
          >
            <Input.Password maxLength={128} />
          </Form.Item>

          <Button
            loading={is_loading}
            disabled={is_loading}
            type="primary"
            htmlType="submit"
            size="large"
            block
          >
            Wyślij
          </Button>
        </Form>
      </div>
    </AuthLayout>
  );
};

export default ChangePassword;
